/* eslint-disable camelcase */
import React from 'react';

import PropTypes from 'prop-types';

import UploadImage from '../../assets/images/notificationicon.jpg';
import { useLocaleContext } from '../context/LocaleContext';
import { getFormattedDate } from '../utils/utils';
import { Button } from '@telus-uds/components-web';
import {
  GET_RESOLVED_DAYS,
  GET_WORKING_DAYS,
  GET_DEFECT_LOCALE
} from './constants';
import EN from '../../EN.json';
import FR from '../../FR.json';
import { isAdmin } from '../utils/request';

const Row = ({ defect, selectedDefect, openModal, headers }) => {
  const locale = useLocaleContext();
  const { DEFECT_MANAGEMENT: { VIEW } = {} } = locale === 'en-US' ? EN : FR;
  const {
    defectWebform = '',
    defectCategory = '',
    createdAt = '',
    name = '',
    priority = '',
    status = '',
    moved_to_in_progress_at = '',
    resolved_at = '',
    defectAssignedTo = {}
  } = defect || {};

  let count = 0;
  const getOpenDays = () => {
    const inProgress = 'In Progress' || 'En cours';
    const resolved = 'Resolved' || 'Résolu';
    const closed =
      'Closed - No response received' || 'Fermé - aucune réponse reçue';
    if (status === inProgress && moved_to_in_progress_at) {
      // In Progress
      count = GET_WORKING_DAYS(moved_to_in_progress_at);
    }
    if (status === resolved || status === closed) {
      // Resolved Or Closed
      if (moved_to_in_progress_at && resolved_at)
        count = GET_RESOLVED_DAYS(moved_to_in_progress_at, resolved_at);
    }
    return count;
  };
  return (
    <tr>
      {isAdmin ? (
        <td data-header-label={headers[0]}>
          {defect.id}
          {defect.new_update_for_admin === true ? (
            <img
              src={UploadImage}
              style={{ marginBottom: '12px' }}
              width={12}
              height={12}
              alt="upload-file"
            />
          ) : (
            ''
          )}
        </td>
      ) : (
        <td data-header-label={headers[0]}>
          {defect.id}
          {defect.new_update_for_reporter === true ? (
            <img
              src={UploadImage}
              style={{ marginBottom: '12px' }}
              width={12}
              height={12}
              alt="upload-file"
            />
          ) : (
            ''
          )}
        </td>
      )}
      <td data-header-label={headers[1]}>
        {getFormattedDate(createdAt, 'YYYY-MM-DD') || '-'}
      </td>
      <td data-header-label={headers[2]}>{getOpenDays()}</td>
      <td data-header-label={headers[3]}>{GET_DEFECT_LOCALE(defectWebform)}</td>
      <td data-header-label={headers[4]}>{name}</td>
      <td data-header-label={headers[5]}>
        {GET_DEFECT_LOCALE(defectCategory)}
      </td>
      <td data-header-label={headers[6]}>{GET_DEFECT_LOCALE(priority)}</td>
      <td data-header-label={headers[7]}>{GET_DEFECT_LOCALE(status)}</td>
      {isAdmin ? (
        <td data-header-label={headers[8]}>
          {defectAssignedTo
            ? `${defectAssignedTo.firstName} ${defectAssignedTo.lastName}`
            : ''}
        </td>
      ) : (
        ''
      )}
      <td data-header-label={headers[9]}>
        <div className="responsive-table__actions">
          <Button
            variant={{ text: true }}
            onClick={() => {
              selectedDefect(defect);
              openModal(true);
            }}
            style={{ textDecoration: 'underline' }}
          >
            {VIEW}
          </Button>
        </div>
      </td>
    </tr>
  );
};

Row.propTypes = {
  defect: PropTypes.objectOf(PropTypes.object).isRequired,
  selectedDefect: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  headers: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default Row;
